import * as React from "react";
const SvgTrailMiddle = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { width: 10, viewBox: "0 0 9 34", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 24V24C4.58173 24 1.00001 20.4183 1.00001 16L1.00001 0L1 48", stroke: "#C5C6D0" }));
export default SvgTrailMiddle;
